import type { ProductVariation } from 'models/productsReferential';

export function isEqual(a: ProductVariation, b: ProductVariation) {
  return a.productType === b.productType && a.productSubType === b.productSubType && a.wrapper === b.wrapper;
}
export function getProductNameForAnalytics(productVariation: ProductVariation) {
  return `${productVariation.productType}.${productVariation.productSubType}.${productVariation.wrapper}`;
}
